import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { CoreConstants } from "../../../core/models/constants/core.constants";
import DynamicForm from "../../../core/presentations/DynamicForm";
import { useToasterFacade } from "../../../ui/facades/toaster.facade";
import Validators from "../../../ui/helpers/validators";
import TopLabelFieldTemplate from "../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../ui/templates/objects/VerticalFormTemplate";
import PrwcBasicButton from "../../../ui/widgets/custom/buttons/PrwcBasicButton";
import PrwcOutlinedButton from "../../../ui/widgets/custom/buttons/PrwcOutlinedButton";

const SignIn = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const toasterFacade = useToasterFacade();
  const [formData, setFormData] = useState(null);

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const validationSchema: any = {
    workEmailId: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "signIn.validation.workEmailRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isRegexPatternValid(
              CoreConstants.REGEX_EMAIL,
              value
            );
          },
          messageKey: "signIn.validation.workEmailInvalid",
        },
        {
          validate: (value: string) => {
            return !Validators.isPersonalEmail(value);
          },
          messageKey: "signIn.validation.workEmailNotWorkEmail",
        },
      ],
    },
    password: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "signIn.validation.passwordRequired",
        },
      ],
    },
  };

  const schema: any = {
    type: "object",
    properties: {
      workEmailId: {
        type: "string",
        title: t("signIn.label.workEmailId"),
        default: "",
      },
      password: {
        type: "string",
        title: t("signIn.label.password"),
      },
    },
    required: ["workEmailId", "password"],
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    workEmailId: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
    },
    password: {
      "ui:widget": "prwPassword",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
    },
  };

  const onSubmit = (data: any) => {
    toasterFacade.showSuccess(t("signIn.msg.success.loggedInSuccessfully"));
    history.replace("/home");
  };

  const onError = (data: any) => {};

  const handleCreateOne = () => {
    history.push("signup");
  };

  const handleForgotPassword = () => {
    history.push("forgot-password");
  };

  const handleSignInWithSSO = () => {
    console.log("with sso");
    toasterFacade.showInfo(
      "Not supported at the moment. We are working on it."
    );
  };

  const formButtons = () => {
    return (
      <PrwcBasicButton
        type="submit"
        labelKey="signIn.action.signIn"
        className="bg-blue-700 p-col-12 p-button-sm"
      ></PrwcBasicButton>
    );
  };

  return (
    <div className="p-6 bg-gray-100 rounded-md">
      <div className="text-2xl font-semibold">{t("signIn.label.signIn")}</div>
      <div className="text-sm ">
        {t("signIn.label.typeInYourRegisteredEmail")}
      </div>
      <div className="mt-4">
        <DynamicForm
          onChange={onChange}
          formData={formData}
          onSubmit={onSubmit}
          onError={onError}
          schema={schema}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          formButtons={() => formButtons()}
        ></DynamicForm>
      </div>
      <div className="flex flex-col items-center justify-between my-2 lg:flex-row ">
        <div>
          <span className="text-sm font-medium">
            {t("signIn.label.noAccount")}
          </span>
          <span
            onClick={handleCreateOne}
            className="mx-1 text-sm font-medium text-blue-700 cursor-pointer"
          >
            {t("signIn.label.createOne")}
          </span>
        </div>
        <span
          onClick={handleForgotPassword}
          className="mx-1 text-sm font-medium text-blue-700 cursor-pointer"
        >
          {t("signIn.label.forgotPassword")}
        </span>
      </div>
      <div className="my-3 text-sm font-semibold text-center">
        {t("signIn.label.or")}
      </div>
      <div>
        {/* <Button
          type="button"
          className="p-button-outlined p-button-sm p-col-12"
          label={t("signIn.action.signInWithSSO")}
          onClick={handleSignInWithSSO}
        /> */}

        <PrwcOutlinedButton
          className="p-button-outlined p-button-sm p-col-12"
          labelKey="signIn.action.signInWithSSO"
          onClick={handleSignInWithSSO}
        ></PrwcOutlinedButton>
      </div>
    </div>
  );
};

export default SignIn;
